import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "@/App.css";
import { navurl } from "@/Config/Routeconfig/NavigationUrl";
import SuccessMessage from "@/Components/Form/SuccessMessage";
import { LuCheck } from "@/Components/Icons/Icons.jsx"; // fallback

function SetNewPasswordSucc() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLoginSubmit = () => {
    navigate(navurl.Login);
  };
  
  
  return (
    <Box>
      <Box>
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: 280, sm: 400, md: 400, lg: 400 },
          }}
        >
          <SuccessMessage
            loading={loading}
            onSubmit={handleLoginSubmit}
            label="You have successfully changed the password."
            icon={LuCheck}
            width= {"100%"}
          />
        
        </Box>  
      </Box>
    </Box>
  );
}

export default SetNewPasswordSucc;
